import newResource, { en as newResourceEN, ca as newResourceCA } from './NewResource/newResource'
import resources, { en as resourcesEN, ca as resourcesCA } from './Resources/resources'
import kreaActions, { en as kreaActionsEN, ca as kreaActionsCA } from './kreaActions'
import kreaFileUploader, { en as kreaFileUploaderEN, ca as kreaFileUploaderCA } from './kreaFileUploader'
import kreaCategory, { en as kreaCategoryEN, ca as kreaCategoryCA } from './kreaCategory'
import educationalContent, { en as educationalContentEN, ca as educationalContentCA } from './EducationalContent/educationalContent'
import kreaTextArea, { en as kreaTextAreaEN, ca as kreaTextAreaCA } from './kreaTextArea'
import resource, { en as resourceEN, ca as resourceCA } from './Resource/resource'
import navbar, { en as navbarEN, ca as navbarCA } from './navbar'
import createContent, { en as createContentEN, ca as createContentCA } from './createContent'
import contentList, { en as contentListEN, ca as contentListCA } from './contentList'
import languageSelector, { en as languageSelectorEN, ca as languageSelectorCA } from './languageSelector'
import loaderToast, { en as loaderToastEN, ca as loaderToastCA } from './loaderToast'
import publishContentModal, { en as publishContentModalEN, ca as publishContentModalCA } from './publishContentModal'
import deleteModal, { en as deleteModalEN, ca as deleteModalCA } from './deleteModal'
import addResourceLanguageModal, { en as addResourceLanguageModalEN, ca as addResourceLanguageModalCA } from './addResourceLanguageModal'
import inRevision, { en as inRevisionEN, ca as inRevisionCA } from './inRevision'
import emptyContentList, { en as emptyContentListEN, ca as emptyContentListCA } from './emptyContentList'
import progressBar, { en as progressBarEN, ca as progressBarCA } from './progressBar'
import suggestTopicModal, { en as suggestTopicModalEN, ca as suggestTopicModalCA } from './suggestTopicModal'
import customFields from './CustomFields/customFields'

export default {
  krea: 'Krea',
  exitPreview: 'Continuar editando',
  createContentButton: 'Crear contenido',
  creationsTypes: {
    own: 'Mis creaciones',
    collaborations: 'Colaboraciones'
  },
  kreaCategory,
  kreaTextArea,
  newResource,
  resources,
  kreaActions,
  kreaFileUploader,
  educationalContent,
  resource,
  navbar,
  createContent,
  contentList,
  languageSelector,
  loaderToast,
  publishContentModal,
  deleteModal,
  addResourceLanguageModal,
  inRevision,
  emptyContentList,
  progressBar,
  suggestTopicModal,
  customFields
}

export const en = {
  krea: 'Krea',
  exitPreview: 'Continue editing',
  createContentButton: 'Crear contenido',
  creationsTypes: {
    own: 'My creations',
    collaborations: 'Collaborations'
  },
  kreaCategory: kreaCategoryEN,
  kreaTextArea: kreaTextAreaEN,
  newResource: newResourceEN,
  resources: resourcesEN,
  kreaActions: kreaActionsEN,
  kreaFileUploader: kreaFileUploaderEN,
  educationalContent: educationalContentEN,
  resource: resourceEN,
  navbar: navbarEN,
  createContent: createContentEN,
  contentList: contentListEN,
  languageSelector: languageSelectorEN,
  loaderToast: loaderToastEN,
  publishContentModal: publishContentModalEN,
  deleteModal: deleteModalEN,
  addResourceLanguageModal: addResourceLanguageModalEN,
  inRevision: inRevisionEN,
  emptyContentList: emptyContentListEN,
  progressBar: progressBarEN,
  suggestTopicModal: suggestTopicModalEN
}

export const ca = {
  krea: 'Krea',
  exitPreview: 'Continuar editant',
  createContentButton: 'Crear contenido',
  creationsTypes: {
    own: 'Les meves creacions',
    collaborations: 'Col·laboracions'
  },
  kreaCategory: kreaCategoryCA,
  kreaTextArea: kreaTextAreaCA,
  newResource: newResourceCA,
  resources: resourcesCA,
  kreaActions: kreaActionsCA,
  kreaFileUploader: kreaFileUploaderCA,
  educationalContent: educationalContentCA,
  resource: resourceCA,
  navbar: navbarCA,
  createContent: createContentCA,
  contentList: contentListCA,
  languageSelector: languageSelectorCA,
  loaderToast: loaderToastCA,
  publishContentModal: publishContentModalCA,
  deleteModal: deleteModalCA,
  addResourceLanguageModal: addResourceLanguageModalCA,
  inRevision: inRevisionCA,
  emptyContentList: emptyContentListCA,
  progressBar: progressBarCA,
  suggestTopicModal: suggestTopicModalCA
}
